/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Error_ButtonInputs */

const en_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const id_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

const ms_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin`)
};

const ca_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const cs_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const da_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiér`)
};

const de_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const et_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopeeri`)
};

const es_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const hr_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj`)
};

const it_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const lv_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopēt`)
};

const lt_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopijuoti`)
};

const hu_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Másolás`)
};

const nl_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieer`)
};

const nb_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier`)
};

const pl_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiuj`)
};

const pt_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const ro_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiază`)
};

const sk_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovat`)
};

const sl_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj`)
};

const fi_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi`)
};

const sv_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera`)
};

const vi_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép`)
};

const tr_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyala`)
};

const el_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγραφή`)
};

const bg_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копиране`)
};

const ru_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать`)
};

const sr_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирај`)
};

const uk_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопіювати`)
};

const ka_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`კოპირება`)
};

const hi_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी बनाएं`)
};

const th_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอก`)
};

const ko_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사`)
};

const zh_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const zh_tw_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製`)
};

const ja_copy_error_button = /** @type {(inputs: Copy_Error_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Copy_Error_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copy_error_button = /** @type {((inputs?: Copy_Error_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Error_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copy_error_button(inputs)
	if (locale === "ms") return ms_copy_error_button(inputs)
	if (locale === "ca") return ca_copy_error_button(inputs)
	if (locale === "cs") return cs_copy_error_button(inputs)
	if (locale === "da") return da_copy_error_button(inputs)
	if (locale === "de") return de_copy_error_button(inputs)
	if (locale === "et") return et_copy_error_button(inputs)
	if (locale === "es") return es_copy_error_button(inputs)
	if (locale === "fr") return fr_copy_error_button(inputs)
	if (locale === "hr") return hr_copy_error_button(inputs)
	if (locale === "it") return it_copy_error_button(inputs)
	if (locale === "lv") return lv_copy_error_button(inputs)
	if (locale === "lt") return lt_copy_error_button(inputs)
	if (locale === "hu") return hu_copy_error_button(inputs)
	if (locale === "nl") return nl_copy_error_button(inputs)
	if (locale === "nb") return nb_copy_error_button(inputs)
	if (locale === "pl") return pl_copy_error_button(inputs)
	if (locale === "pt") return pt_copy_error_button(inputs)
	if (locale === "ro") return ro_copy_error_button(inputs)
	if (locale === "sk") return sk_copy_error_button(inputs)
	if (locale === "sl") return sl_copy_error_button(inputs)
	if (locale === "fi") return fi_copy_error_button(inputs)
	if (locale === "sv") return sv_copy_error_button(inputs)
	if (locale === "vi") return vi_copy_error_button(inputs)
	if (locale === "tr") return tr_copy_error_button(inputs)
	if (locale === "el") return el_copy_error_button(inputs)
	if (locale === "bg") return bg_copy_error_button(inputs)
	if (locale === "ru") return ru_copy_error_button(inputs)
	if (locale === "sr") return sr_copy_error_button(inputs)
	if (locale === "uk") return uk_copy_error_button(inputs)
	if (locale === "ka") return ka_copy_error_button(inputs)
	if (locale === "hi") return hi_copy_error_button(inputs)
	if (locale === "th") return th_copy_error_button(inputs)
	if (locale === "ko") return ko_copy_error_button(inputs)
	if (locale === "zh") return zh_copy_error_button(inputs)
	if (locale === "zh-tw") return zh_tw_copy_error_button(inputs)
	if (locale === "ja") return ja_copy_error_button(inputs)
	return en_copy_error_button(inputs)
});